import { z } from 'zod';

export const onboardingConfigSchema = z.object({
    enabled: z.boolean(),
    usableLanes: z.number().int().nonnegative(),
});

export const onboardingStatusSchema = z.object({
    state: z.enum([
        'notRedeemed',
        'queued',
        'ready',
        'admitted',
        'provisioning',
        'completed',
        'missed',
        'cancelled',
        'disabled',
    ]),
    position: z.number().int().positive().nullable().default(null),
    usersAhead: z.number().int().nonnegative().nullable().default(null),
    estimatedWaitMinutes: z
        .object({
            min: z.number().nonnegative(),
            max: z.number().nonnegative(),
        })
        .nullable()
        .default(null),
    readyExpiresAt: z.string().nullable().default(null),
    admissionExpiresAt: z.string().nullable().default(null),
    walletAddress: z.string().nullable().default(null),
    lastError: z.string().nullable().default(null),
    // Machine-readable companion to `lastError`. Optional on the wire: older
    // deployments only send the sentence, so the default keeps them parsing.
    lastErrorCode: z.string().nullable().default(null),
    pollAfterMs: z.number().int().min(1_000).default(60_000),
});

export const onboardingWalletStartSchema = z.object({
    status: z.enum(['completed', 'provisioning']),
    walletAddress: z.string().nullable().default(null),
    alreadyExisted: z.boolean().default(false),
});
